import styled from "styled-components";
import { bp } from "theme/themevals";


interface CustomProps extends React.HTMLAttributes<HTMLDivElement> {
    $noPadding?: boolean;
  }

export const PageWrapper = styled.div<CustomProps>`
    width:100%;    
    flex-grow: 1;
    display: flex;
    flex-direction: column;    
    padding:${props => props.$noPadding ? "40px 40px 0px 40px" : "40px"};
    @media (max-width: ${bp.lg})  {    
        padding: ${props => props.$noPadding ? "25px 25px 0px 25px" : "25px"};
    }
    @media (max-width: ${bp.sm})  {    
        padding: ${props => props.$noPadding ? "16px 16px 0px 16px" : "16px"};
    }
`

export const PageInner = styled.div`
    width: 100%;
    margin: 0 auto;
    flex: 1;
    display: flex;
    flex-direction: column;
`;


export const PageTitle = styled.div`    
    margin-bottom: 2.5rem;
`;

// Title + optional right-aligned action row. Wraps on narrow viewports
// so the action button stacks below the title instead of overlapping.
export const PageTitleRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
`;

export const PageTitleText = styled.div`
    min-width: 0;
    flex: 1 1 auto;
`;

export const PageTitleActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
`;


export const Subtitle = styled.div`
    font-size: 12px;
    font-weight: 400;
    font-family:"Poppins";
    color:#818181;
    margin-top:5px;
    line-height:18px;
`;
